import http from "../core/http";
import { withFlightDateCache } from "../cache/flightListCache";
const group = 'caseFiles';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}


export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getArrivalFlightListRequest = async (data) =>
	withFlightDateCache(`${group}/getArrivalFlightList`, data, (d) =>
		http.post(`${group}/getArrivalFlightList`, d).then((res) => res.data).catch(http.defaultCatch)
	);
export const getDepartureFlightListRequest = async (data) =>
	withFlightDateCache(`${group}/getDepartureFlightList`, data, (d) =>
		http.post(`${group}/getDepartureFlightList`, d).then((res) => res.data).catch(http.defaultCatch)
	);
export const getFullFlightListRequest = async (data) =>
	withFlightDateCache(`${group}/getFullFlightList`, data, (d) =>
		http.post(`${group}/getFullFlightList`, d).then((res) => res.data).catch(http.defaultCatch)
	);

/** Case header Flight Date → Flight: arrivals only except OHD/UNCLAIMED (arrival + departure). */
export async function getCaseFileHeaderFlightListRequest(data) {
	const t = String(data.Type ?? '').toUpperCase();
	const payload = { Date: data.Date };
	if (t === 'OHD' || t === 'UNCLAIMED') {
		return getFullFlightListRequest(payload);
	}
	return getArrivalFlightListRequest(payload);
}
export const getClaimTypeListRequest =  async (data) => {
	return await http.post(`${group}/getClaimTypeList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getAddressListRequest =  async (data) => {
	return await http.post(`${group}/getAddressList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getUserListRequest =  async (data) => {
	return await http.post(`${group}/getUserList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getDamageBagClaimListRequest =  async (data) => {
	return await http.post(`${group}/getDamageBagClaimList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getForwardTypeListRequest =  async (data) => {
	return await http.post(`${group}/getForwardTypeList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getDPRActionListRequest =  async (data) => {
	return await http.post(`${group}/getDPRActionList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getClaimsActionListRequest =  async (data) => {
	return await http.post(`${group}/getClaimsActionList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getBagStatusListRequest =  async (data) => {
	return await http.post(`${group}/getBagStatusList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const deleteAttachmentRequest =  async (data) => {
	return await http.post(`${group}/deleteAttachment`, data).then(res => res.data).catch(http.defaultCatch);
}
export const receiveAllRequest =  async (data) => {
	return await http.post(`${group}/receiveAll`, data).then(res => res.data).catch(http.defaultCatch);
}
export const deliverAllRequest =  async (data) => {
	return await http.post(`${group}/deliverAll`, data).then(res => res.data).catch(http.defaultCatch);
}
export const forwardAllRequest =  async (data) => {
	return await http.post(`${group}/forwardAll`, data).then(res => res.data).catch(http.defaultCatch);
}
export const createNoteRequest =  async (data) => {
	return await http.post(`${group}/createNote`, data).then(res => res.data).catch(http.defaultCatch);
}
export const sendAirlineMailRequest =  async (data) => {
	return await http.post(`${group}/sendAirlineMail`, data).then(res => res.data).catch(http.defaultCatch);
}
export const closeCaseRequest =  async (data) => {
	return await http.post(`${group}/closeCase`, data).then(res => res.data).catch(http.defaultCatch);
}
export const reopenCaseRequest =  async (data) => {
	return await http.post(`${group}/reopenCase`, data).then(res => res.data).catch(http.defaultCatch);
}

